var _style, _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _g3, _path35, _g4, _g5, _g6, _path36, _defs2, _g7, _path37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNotfound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 772",
    style: {
      enableBackground: "new 0 0 800 772"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#8D8D8D;}\r\n\t.st2{fill:none;stroke:#707070;stroke-miterlimit:10;}\r\n\t.st3{fill:#444444;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st5{fill:#F4F4F4;}\r\n\t.st6{fill:#D9D9D9;}\r\n\t.st7{opacity:0.75;fill:none;stroke:#FFFFFF;stroke-miterlimit:10;enable-background:new    ;}\r\n\t.st8{opacity:0.32;fill:#2E2E2E;enable-background:new    ;}\r\n\t.st9{fill:url(#Caminho_256_2_);}\r\n\t.st10{fill:#FF735F;}\r\n\t.st11{fill:#03E548;}\r\n\t.st12{fill:#DB6352;}\r\n\t.st13{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st14{fill:url(#Caminho_273_2_);}\r\n\t.st15{fill:url(#Caminho_274_2_);}\r\n\t.st16{fill:url(#Caminho_277_2_);}\r\n\t.st17{fill:url(#Caminho_279_2_);}\r\n\t.st18{fill:#FFFFFF;}\r\n\t.st19{opacity:0.49;fill:url(#Caminho_291_2_);enable-background:new    ;}\r\n\t.st20{fill:none;stroke:#C5C5C5;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st21{fill:#CEDFD8;}\r\n\t.st22{clip-path:url(#SVGID_4_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1234.3,370.8c0.3-2.1,1-3.9,2.6-4.9c2.3-1.4,5.4-0.2,8.1-0.7c7.6-1.4,7.5-12,7.3-17.8 c-0.1-3.7-0.3-7.4-0.5-11.1c0-1-0.2-2-0.6-2.8c-1.1-1.5-3-2-4.7-1.5c-3.3,0.9-5.2,4.5-5.8,7.9c-0.6,3.4-0.3,6.9-1.2,10.2 c-0.1,0.6-0.4,1.2-0.7,1.8c-0.4,0.6-1,1.1-1.7,1.4c-1,0.5-2.1,0.5-3.1,0c-1-0.7-0.9-1.5-0.9-2.5c0-1.2-0.1-2.5-0.3-3.7 c-0.3-2.8-0.6-5.6-0.9-8.3c-0.5-5.5-1-11-1.5-16.4c-0.1-2.5-0.7-5-1.8-7.3c-5.4-9.7-13.7-1.2-14.4,5.9c-1.7,16.1,6.7,31.3,6,47.3 c0,0.7-0.1,1.4-0.4,2c-1.3,2.5-5.3,2.1-7.2,0.6c-2.9-2.3-1.9-7.2-1.9-10.2c0-2.4-0.8-5.2-3.1-6.3c-2.7-1.3-6.1,0.3-7.6,2.6 c-2,3.1-1.7,8.3-1.4,11.7c0.1,2.5,0.9,4.9,2.3,7.1c1.5,2.2,3.9,3.6,6.6,3.9c1.6,0.1,3.3-0.2,4.5,0.7c1.4,1.1,0.9,3.2,1,5 c0.1,3.5,3.1,6.4,6.5,7.9s7.3,1.7,11.1,1.9c3.2-5.1,3.4-11.1,3.6-16.8C1234,375.8,1234.1,373.3,1234.3,370.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    transform: "translate(331.173 330.179)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    className: "st1",
    d: "M903.1,40.7c0.3-2.1,1-3.9,2.6-4.9c2.3-1.4,5.4-0.2,8.1-0.7c7.6-1.4,7.5-12,7.3-17.8 c-0.1-3.7-0.3-7.4-0.5-11.1c0-1-0.2-2-0.6-2.8c-1.1-1.5-3-2-4.7-1.5c-3.3,0.9-5.2,4.5-5.8,7.9c-0.6,3.4-0.3,6.9-1.2,10.2 c-0.1,0.6-0.4,1.2-0.7,1.8c-0.4,0.6-1,1.1-1.7,1.4c-1,0.5-2.1,0.5-3.1,0c-1-0.7-0.9-1.5-0.9-2.5c0-1.2-0.1-2.5-0.3-3.7 c-0.3-2.8-0.6-5.6-0.9-8.3c-0.5-5.5-1-11-1.5-16.4c-0.1-2.5-0.7-5-1.8-7.3c-5.4-9.7-13.7-1.2-14.4,5.9 c-1.7,16.1,6.7,31.3,6,47.3c0,0.7-0.1,1.4-0.4,2c-1.3,2.5-5.3,2.1-7.2,0.6c-2.9-2.3-1.9-7.2-1.9-10.2c0-2.4-0.8-5.2-3.1-6.3 c-2.7-1.3-6.1,0.3-7.6,2.6c-2,3.1-1.7,8.3-1.4,11.7c0.1,2.5,0.9,4.9,2.3,7.1c1.5,2.2,3.9,3.6,6.6,3.9c1.6,0.1,3.3-0.2,4.5,0.7 c1.4,1.1,0.9,3.2,1,5c0.1,3.5,3.1,6.4,6.5,7.9s7.3,1.7,11.1,1.9c3.2-5.1,3.4-11.1,3.6-16.8C902.9,45.7,902.9,43.2,903.1,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    className: "st2",
    d: "M892.9-18.9c3.9,26.7,7.2,54,2.4,80.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    className: "st2",
    d: "M889.2-19.1c-1.1,5-2.2,10-2.2,15.1c0,9.7,4.1,18.9,5.7,28.5c1.8,10.7,0.5,21.6-0.9,32.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    className: "st2",
    d: "M897.6,28.1c4.7-0.7,10.2-1.3,13.2-5.1c0.4-0.5,0.8-1.1,1-1.7c0.8-2.5,0.4-5.4,0.4-8 c0-2.5,0-6.9,0-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    className: "st2",
    d: "M893.4,45.9c-4.2,0.7-8.8,1.3-12.4-0.8c-2.1-1.3-3.7-3.3-4.5-5.6c-0.7-2.3-1-4.7-0.9-7 c0-2.6,0.2-5.2,0.7-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    className: "st2",
    d: "M897.6,32.4c5.3-0.8,10.5-2.1,15.5-4c1.1-0.3,2.1-0.9,2.9-1.6c0.8-0.9,1.3-1.9,1.5-3 c0.7-2.4,1-19,0.2-23"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302",
    className: "st3",
    d: "M1209,386.3l31.3-0.7l-3.2,23.3l-23.9,0L1209,386.3z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_126_1_",
    className: "st4",
    d: "M128.1,338.6h161.3c24.6,0,44.6,19.9,44.6,44.6v66.9l0,0H128.1 c-24.6,0-44.6-19.9-44.6-44.6v-22.3C83.5,358.6,103.4,338.6,128.1,338.6C128.1,338.6,128.1,338.6,128.1,338.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252_1_",
    className: "st5",
    d: "M545.5,740c57-20.1,112.2-54.5,148.2-104.6c44.2-61.3,40.4-130.8,49.4-202.4 c3.7-29.1,23.2-45.8,34.7-71.6c24.5-54.4,15.8-136.4-35.6-173.3c-31.7-22.8-62.3-25.3-79.3-64.9c-9.4-21.9-14.9-46-29.6-64.8 c-21.2-27.2-57.2-37.9-91.3-43.3c-39.7-6.3-78.4-4.9-118.2-6C381.5,7.8,338.5,9,297.3,20.2c-55.9,15.3-117.3,55.3-127,116.2 c-4.2,26.1,1.3,54-8.6,78.5c-14.9,36.9-54.7,49.4-84.3,71.2C45.6,309.4,25,346,15.9,383.9c-15.5,64.7-4.1,136.4,26,195.2 c32.2,62.9,84.5,116.4,148,147.8c49.7,24.6,118.4,31.9,174.4,35.4C425.5,766,487.9,760.3,545.5,740z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_253_1_",
    className: "st6",
    d: "M691.4,487.5c-0.4-92.4-25.9-181.2-101.1-240.7c-92.8-73.5-222.5-72.5-317.3-4 c-62,44.8-105.5,112.3-129.9,184.8S112.4,577.7,115,654.2l564.6,1.8c2.4-26,4.7-51.9,7.1-77.9C689.4,548.3,691.5,517.9,691.4,487.5 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_127_1_",
    className: "st7",
    d: "M159.1,328.3h161.3c24.6,0,44.6,19.9,44.6,44.6v66.9l0,0H159.1 c-24.6,0-44.6-19.9-44.6-44.6v-22.3C114.5,348.2,134.5,328.3,159.1,328.3C159.1,328.3,159.1,328.3,159.1,328.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_128_1_",
    className: "st7",
    d: "M285.9,108.5h224.6c32.5,0,58.9,26.4,58.9,58.9c0,0,0,0,0,0v88.5l0,0H285.9 c-32.5,0-58.9-26.4-58.9-58.9c0,0,0,0,0,0v-29.6C227,134.9,253.3,108.5,285.9,108.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139_1_",
    transform: "translate(79.638 275.129)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_254_1_",
    className: "st1",
    d: "M131.5,364.3c-0.8-0.6-1.6-1.2-2.4-1.8c-2.9-2.3-3.5-6.5-3.8-10.2 c-3.7-45.5,3.1-91.3,0.9-136.9c-0.5-10.9-9.3-5.5-16.6-4.1c-1.1,0.2-15.2,2.8-15,1.2c-1.3,13-2.9,26.8-11.5,36.6 c-5.9,6.8-14.4,10.6-21.9,15.7c-28,19-44.4,55.7-48.5,88.8c-0.1-0.7-0.1-1.5-0.2-2.2c-0.5-6.6-1-13.2-1.3-19.8 c-0.7-13.9-0.9-27.8-0.6-41.7c0.2-10.3,1.5-21.6-4.8-30.6c-5.3-7.6-11.2-8.2-18.7-8.8c-2-4.1-1.7-12.2-1.7-15.9 c0-5.9,1-12.6,5.3-17.1c7.1-7.4,18.1-2.9,27-5.1c20.3-5.1,13.1-31,11.7-45.9c-0.8-9.2-15.3-9.3-14.5,0c0.7,7.5,2.2,15.3,2.1,22.8 c-0.1,4.8,0.1,7.9-5.1,9.4c-2.3,0.3-4.7,0.3-7,0c-10.6-0.1-19.6,2.3-26.4,10.8c-7.3,9.3-8.5,21.2-7.2,32.6 c0.9,8.6,1.3,20.7,11.8,22.5c9.8,1.7,12.8,3.7,13.1,14.1c0.2,7-0.4,14.1-0.4,21.1c-0.1,15.9,0.5,31.7,1.7,47.6 c0.7,9-0.8,25.5,6.8,32.3c3.3,3.1,8.2,3.8,12.2,1.7c12,0.7,40.5-1,43.6-1H97c6.2,0,17,2.1,22.9-0.9c3.2-1.6,8.9-4.6,11.2-7.4 C132.9,369.9,133.5,366.4,131.5,364.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_255_1_",
    className: "st8",
    d: "M126.6,228.7c0.1-3.7,0-7.4-0.3-11.1c0-0.7-0.1-1.4-0.2-2.1c-0.1-0.8-0.4-1.5-0.7-2.2 c-2.7-5.2-12.2-0.7-15.9,1.1c-4.1,2.1-8,4.6-11.6,7.4c-2.3,1.5-4.3,3.6-5.7,6c-1.2,2.6-0.5,6.8-0.3,9.6c0,2.1,0.7,4.2,1.9,6 c1.3,1.8,3.7,2.4,5.7,1.5c0.3,2.3,0.9,4.5,1.9,6.5c0.9,1.5,2.3,2.7,4.1,3.2c1.2,0.3,1.1,0.1,1.5,1.4c0,0,0,0.1,0,0.1 c0.2,0.9,0.6,1.8,1.1,2.7c0,0.1,0.1,0.1,0.1,0.2c0.3,0.6,0.7,1.2,1.2,1.6c0.3,0.2,0.6,0.4,1,0.6l0,0l0,0c0.7,0.4,1.5,0.7,2.3,0.8 c2.1,0.3,4.2-0.6,5.4-2.3c1-2.1,1.3-4.4,0.9-6.6c1.7,0,3.1-1.1,3.8-2.6c0.6-1.9,0.8-3.8,0.6-5.8c0-2.2-0.1-4.5-0.2-6.7 C127.5,238.5,126.5,231.7,126.6,228.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_256_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -80.1609,
    y1: 505.12,
    x2: -77.0121,
    y2: 505.8922,
    gradientTransform: "matrix(21.3421 0 0 -39.9383 1767.8455 20526.6992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E2E2E",
      stopOpacity: 0.914
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#2E2E2E",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#311573",
      stopOpacity: 0
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_256_1_",
    className: "st9",
    d: "M78.8,302.8c7.5,4.6,11.9,13,11.2,21.8c-0.9,9-8,16.1-14.5,21.6 c-6.9,5.7-14.5,11-18.9,18.8c4.5-0.6,9-0.9,13.5-1c3.9-0.1,8.4,0.2,10.6,3.4c2.4,3.3,1.1,7.9,1.7,11.9c0.5,0.3,1,0.1,1.4-0.3 c0.3,1,0.2,1.1,1.3,1c3.7-0.5,6.8-2.9,8.4-6.2c1.5-3.3,2.4-6.9,2.6-10.5c1.7-12.9,2.2-25.9,1.5-38.9c0-4.1-1-8.2-2.9-11.9 C91.3,306.6,85.7,302.2,78.8,302.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_257_1_",
    className: "st1",
    d: "M60.7,182.6c-0.2-0.6-0.4-1.3-0.5-1.9c0.1,0.3,1.8,0.9,2.1,1.1c0.7,0.4,1.5,0.8,2.2,1.2 c1.5,0.8,2.9,1.7,4.4,2.5c1.5,0.9,2.9,1.7,4.3,2.6c0.6,0.4,1,0.8,1.7,0.6c1.1-0.3,2.1-0.7,3.1-1.2c1.2-0.5,2.5-1,3.7-1.5 c2.5-1,5-2,7.5-2.9c4.9-1.9,9.9-3.9,14.7-6c1.9-0.8,6.1-1.9,6.9-4c0.2-0.8,0.3-1.5,0.3-2.3c0.2-4,1-11.4,1-11.4s3,2.5,3.4,3.1 c1.1,1.3,2.1,2.6,3.1,3.9c2,2.7,3.8,5.5,5.4,8.4c3.4,6.2,6.3,12.6,8.7,19.3c1.9,5.3,2.9,10.7-0.7,15.5c-3.3,4.5-8.6,7.3-13.4,9.8 c-9.9,5.1-20.4,10.8-31.6,11.9c-2.8,0.4-5.7,0.1-8.3-1.1c-2.5-1.5-4.5-3.7-5.8-6.3C65.9,210.9,64.5,196.5,60.7,182.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_258_1_",
    d: "M115.9,211.1c-3.3-1.1-6.7-1.3-10-2.2c0.2-0.3,0.4-0.7,0.6-1c0.5-0.9,1-1.7,1.4-2.6 c0.3-0.5,0.1-1.1-0.4-1.4c-0.1,0-0.1-0.1-0.2-0.1c-1.1-0.4-2.9,0.6-3.9,0.9c-1.6,0.5-3.1,1.2-4.6,2.1c-0.5,0.3-0.6,1-0.3,1.4 c0.1,0.2,0.3,0.4,0.6,0.4l4.2,1.3c-1.4,3.5-2.6,7.1-3.6,10.7c-0.1,0.6,0.2,1.1,0.8,1.2c0.5,0.1,1-0.2,1.2-0.7 c1-3.5,2.2-7,3.5-10.4c3.4,1,6.9,1.2,10.2,2.3C116.6,213.5,117.2,211.5,115.9,211.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_259_1_",
    d: "M87.6,202.4c-0.4-0.2-0.9-0.2-1.3,0c-0.3,0-0.6,0.1-0.7,0.3c-0.2,0.3-0.3,0.5-0.4,0.9 c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3,0,0.6,0.2,0.9c0.1,0.3,0.3,0.6,0.5,0.8c0.9,0.7,2.1,0.6,2.8-0.3c0.1-0.1,0.1-0.1,0.2-0.2 c0.5-0.9,0.3-2.1-0.6-2.6C87.8,202.5,87.7,202.4,87.6,202.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_260_1_",
    d: "M118.6,190c-0.4-0.2-0.9-0.2-1.3,0c-0.3,0-0.6,0.1-0.7,0.3c-0.2,0.3-0.3,0.5-0.4,0.9 c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.3,0,0.6,0.2,0.9c0.1,0.3,0.3,0.6,0.5,0.8c0.9,0.7,2.1,0.6,2.8-0.3c0.1-0.1,0.1-0.1,0.2-0.2 c0.5-0.9,0.3-2.1-0.6-2.6C118.9,190.1,118.7,190,118.6,190z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_129_1_",
    className: "st7",
    d: "M562,269.5h103c26.1,0,47.2,21.1,47.2,47.2l0,0v6.5c0,26.1-21.1,47.2-47.2,47.2l0,0 H514.8l0,0v-53.7C514.8,290.6,536,269.5,562,269.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140_1_",
    transform: "translate(181.378 215.253)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_261_1_",
    className: "st10",
    d: "M70.4,384c-3.9,13.5-7.3,29.1,0.6,40.7c9.6,13.9,31.6,13.8,45.4,4 c13.8-9.8,21.3-26,27.7-41.7c10.8-26.4,20.3-53.6,24-81.9c2.2-16.5,0.3-37.1-14.7-44.3c-23.1-11.2-42.8,6.6-50.2,26.2 C91,319,79.9,351.2,70.4,384z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_262_1_",
    className: "st11",
    d: "M140.5,213.5c-5.9,6.3-11.3,13.2-15.9,20.5c-6.5,10.1-10.9,21-16,31.8 c-1.8,3.8-16.8,36.7-13.5,39.1c18.9,13.5,37.4,28.2,59,36.5c0.7,0.3-3.4,16.1-3.8,17.6c-1.5,5.9-2.8,11.8-4,17.7 c-2.4,11.8-4.2,23.7-6.3,35.6c-1.2,6.6-2.3,13.2-3.4,19.8c-0.5,3,93.5,9.2,102,9.3c24.9,0.4,63.9,7.3,79-18 c3.3-6.2,5.7-12.8,7-19.7c9.2-40,13.4-81,12.3-122c0-9.6-1-19.2-3.1-28.6c-3.4-13.6-10.5-25.8-18-37.5 c-6.8-10.7-17.5-16.6-28.9-22c-34.2-16.4-75.4-21.6-110.1-6.3C163.1,193.4,150.7,202.4,140.5,213.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_263_1_",
    className: "st10",
    d: "M296.7,310.3c-0.9,2.2-1.9,4.3-2.8,6.5c-3.6,8.3-12.7,22.8-12.7,31.9 c-4.2,13.3-6.3,27.5-3.8,41.1c1.1,5.5,2.6,10.8,4.5,16.1c2,6.7,5,13.1,9,18.9c3.8,5.1,12.8,13,19.8,10.3 c7.3-2.8,12.8-16.1,15.6-22.7c16.6-39,23.1-81.7,27.2-123.6c1.5-7.4-1-15-6.5-20.1c-3.6-4.5-7.8-9.3-13.5-10.3 c-5.5-1-11.1,1.9-14.8,6c-3.5,4.3-6.3,9.2-8.2,14.4C305.7,289.3,301.2,299.8,296.7,310.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_264_1_",
    className: "st11",
    d: "M326.7,305.9c-3.2-0.9-47.8-11.7-47.9-6.2c0.3-24.2,1.7-48.4,4-72.5 c0.7-7.7,1.6-15.5,4.5-22.6c2.9-7.1,8.2-13.7,15.4-16.4c5.4-1.8,11.3-2,16.8-0.6c17.9,4.1,32,17.8,36.6,35.6 c1.6,7.5,2.2,15.2,1.8,22.9c-0.2,22.8-1.9,45.6-3.2,68.3C345.2,314.1,335.9,308.4,326.7,305.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_265_1_",
    className: "st12",
    d: "M349.4,183.1c0.6,2.1,1,4.2,1.1,6.3c0.9,14.5-8.6,26.7-18.2,36.5 c-3.8,3.8-9,6.5-12.4,10.5c-3.9,4.6-3.7,12.1-10.4,14.1c-4.4,1.2-8.9-1.4-10-5.8c-0.5-1.9-0.3-4,0.6-5.8c1.4-3.9,2.7-8.8,5.1-12.3 c1.9-2.8,5.6-4.6,8.4-6.3c5.8-3.6,9.9-9.5,11-16.2c1.8-12.2,0-26,4.2-37.7c0.6-2.1,1.8-3.9,3.3-5.4c1.6-1.5,3.9-2.1,6-1.5 c3,1,4.2,4.5,5.2,7.5C345.1,172.4,347.8,177.6,349.4,183.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_266_1_",
    className: "st12",
    d: "M333.4,336.7c1.4,26.1,1.1,52.7-6,78.1c-2.1,7.6-5.6,18.4-13,22.6 c-8.3,4.8-21.2,0.9-28.9-3.5c-5.2-2.7-9.7-6.6-13.1-11.4c-5.1-7.7-5.3-17.6-4.7-26.8c1.6-24.8,7.7-47.8,12.5-72 c5.2-26.3,11.3-52.4,18.3-78.3c3-11.1,6.8-19.3,16.1-26.3c6.6-5,17.7-11.5,18.3,1.4C334.6,259.2,331.4,297.9,333.4,336.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_267_1_",
    className: "st10",
    d: "M229,204.3c-0.8,1.4-1.5,2.8-1.8,4.4c-0.3,2-0.3,4.1,0,6.1c1.9,15.1,5,30.1,21.2,34.8 c11.3,3.2,23.4,2,33.8-3.5c3.2-1.7,6.2-3.8,8.7-6.3c2.6-2.6,4.2-6,4.4-9.6c10.9,2.4,22.1-8.7,27.8-16.6 c13-18.2,17.3-41.1,15.3-63.1c-0.5-5.4-1.3-11.1-4.6-15.4c-2.5-2.9-5.4-5.3-8.7-7.2c-14.9-9.5-30.7-10-47-2.5 c-14.8,6.8-25,21.4-32,35.6c-2.9,5.9-3.4,13.8-5.7,20.1c-2.7,7.5-6.2,14.6-10.3,21.4C229.8,203,229.4,203.7,229,204.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_268_1_",
    d: "M249.6,127.8c3.1-7.4,8-13.8,14.4-18.7c11.2-7.8,27.4-6.3,39.9-3.5c7.2,1.6,14.5,4.8,22,4.7 c6.8-0.1,13.8-6.9,20.4-4.6c3,1.1,5.2,3.5,5.9,6.6c1.1,5-2,9.7-4.4,14.2c-1.7,3.7-3.6,7.2-5.9,10.5c-3.3,4.4-8.1,7.3-13.5,8.2 c-1.8,0.1-3.6,0.1-5.4-0.2c-10.7-1.1-19.7-4.1-27.8,4.4c-5.6,5.7-8.3,13.6-12.4,20.4c-0.9,1.7-2.2,3.2-3.8,4.3 c-2.2,1.3-4.9,1.3-7.3,1.9c-10.6,2.5-17.6,20.2-28.8,16.4c-9.6-3.3-7.4-12-3.6-18.9c4.7-8.6,3.8-19,5.2-28.7 C245.5,138.9,247.1,133.2,249.6,127.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_269_1_",
    className: "st10",
    d: "M252.2,168.9c-2.4,3.3-3.9,7.2-4.6,11.2c-0.9,3.4-0.8,7,0,10.4c0.9,3.5,3.7,6.1,7.2,6.9 c2.8,0.3,5.6-0.6,7.6-2.5c4.9-4.3,10.8-17.6,9.3-24.4C269.8,160.9,257.1,162.6,252.2,168.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_270_1_",
    className: "st13",
    d: "M262,172.4c-2.7,1.1-4.9,3.2-6.1,6c-1.1,2.7-1.9,5.5-2.3,8.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_271_1_",
    d: "M332.2,174.5c0.3,1.3-0.5,2.6-1.8,2.9c-1.3,0.3-2.6-0.5-2.9-1.8s0.5-2.6,1.8-2.9c0,0,0,0,0,0 C330.6,172.3,331.9,173.1,332.2,174.5C332.2,174.5,332.2,174.5,332.2,174.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_272_1_",
    d: "M305.1,176.5c0.2,1.3-0.7,2.6-2,2.8c-1.3,0.2-2.6-0.7-2.8-2c-0.2-1.3,0.7-2.6,2-2.8c0,0,0,0,0,0 C303.6,174.3,304.9,175.2,305.1,176.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_273_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -176.662,
    y1: 562.8453,
    x2: -175.8027,
    y2: 564.7768,
    gradientTransform: "matrix(34.2142 0 0 -33.1406 6320.7456 19098.0059)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.914
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_273_1_",
    className: "st14",
    d: "M269.9,375.5c-1.1,6.7-1.9,13.5-2.3,20.3c-0.6,9.2-0.3,19.1,4.7,26.8 c3.4,4.8,7.9,8.7,13.1,11.4c7.7,4.4,20.7,8.2,28.9,3.5c7.3-4.2,10.8-15.1,13-22.6c3.5-12.8,5.6-26,6.2-39.3L269.9,375.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_274_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -177.8593,
    y1: 566.3591,
    x2: -176.5161,
    y2: 565.525,
    gradientTransform: "matrix(26.0407 0 0 -40.263 4783.6694 23132.8516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.914
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#FFCC00",
      stopOpacity: 0
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_274_1_",
    className: "st15",
    d: "M195.7,335.3l-11.3-32.2c0.3,0.8-2,4.4-2.4,5.2c-0.8,1.9-1.7,3.7-2.5,5.6 c-1.7,3.8-3.5,7.7-5.3,11.5c-3.2,7.3-6.8,14.5-10.8,21.4c-3.3-1.1-6.4-2.7-9.1-4.9c-1.1,6.5-3.2,12.7-4.5,19.2 c-0.7,3.4-1.3,6.7-1.9,10.1c-0.3,1.7-0.6,3.4-1,5.1c-0.1,0.7-0.4,4.4-0.9,4.7c17.7-10.3,33.8-23.1,47.9-37.9 c1.2-1.1,2.1-2.5,2.5-4.1C196.4,337.8,196.2,336.5,195.7,335.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_275_1_",
    d: "M333.9,161.3c-3.3-0.5-6.7,0.3-9.5,2.2c-1.4,0.8-1.9,2.5-1.2,3.9c0.8,1.4,2.5,1.9,3.9,1.2 c1.9-1.3,4.2-1.9,6.5-1.5c1.6,0.1,3-1.2,3-2.8C336.7,162.7,335.5,161.4,333.9,161.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_276_1_",
    d: "M310.4,165.8c-4-1.9-8.4-1-12.5,0.1c-3.2,0.9-2.4,6,0.8,5.1c3.2-0.9,6.6-1.9,9.8-0.4 C311.5,172,313.4,167.2,310.4,165.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_277_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -167.9591,
    y1: 561.5018,
    x2: -170.0377,
    y2: 559.4813,
    gradientTransform: "matrix(11.642 0 0 -14.02 2252.1074 8086.1162)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.914
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_277_1_",
    className: "st16",
    d: "M274,221.1c-0.2,5.4-0.4,10.8-0.6,16.2c-0.1,2.8-0.1,5.6-0.2,8.5c0,0.5-0.1,1.5-0.2,2.5 c3.3-0.6,6.6-1.6,9.8-2.8c4.4-2,8.7-4.7,10.9-9.2c0.8-1.8,1.4-3.6,1.9-5.5C288.1,229.2,279.6,226.4,274,221.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_278_1_",
    className: "st10",
    d: "M217.1,440.2c28,3.3,58.9,7,85.8-1c-4.2-6.4-9-12.3-14.4-17.7c-5.4-5.4-12.4-9-20-10.2 c-4-0.4-8-0.2-12,0.4c-7,0.8-16,4.5-22.9,3.9c-5.8-0.5-13.5-5.5-19-7.7c-37.5-14.8-82-35-123-24.3c-20.7,5.5-33.2,22.8-18.9,42.3 c8,10.9,20.9,8.9,33.5,9.1c34,0.6,68,0.3,101.8,4.2C211.1,439.5,214.1,439.9,217.1,440.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_279_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -176.0135,
    y1: 554.2009,
    x2: -177.1263,
    y2: 556.7033,
    gradientTransform: "matrix(16.171 0 0 -14.599 2987.7876 8488.9795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    style: {
      stopColor: "#201B59",
      stopOpacity: 0.914
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#FF735F",
      stopOpacity: 0
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_279_1_",
    className: "st17",
    d: "M146.9,371.3c-0.3-0.5-0.6-0.9-0.8-1.4c-2-3.2-3.8-6.5-5.5-9.8c-2.5,2.6-5.2,5-8.2,7.2 c-3.9,2.7-7.5,5.9-10.7,9.3c-2,2.1-4,4.3-5.9,6.4c0.5,1.2,1,2.4,1.5,3.6c0.2,0.6,0.5,1.2,0.8,1.8c1.3-0.4,2.6-0.9,3.9-1.2 c6.7-1.9,15.4-4.6,22.8-3.5c0.4-4,2-7.9,2.3-11.9C147,371.6,146.9,371.5,146.9,371.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_280_1_",
    className: "st12",
    d: "M309.9,216.7c-1.4,0-2.7,0.7-3.5,1.9c-0.3,0.5-0.2,1.2,0.2,1.6c0.1,0.4,0.4,0.8,0.8,0.9 c1.4,0.3,2.9-0.3,3.7-1.5c0.7-0.6,0.7-1.7,0-2.3C310.8,216.9,310.4,216.7,309.9,216.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281_1_",
    className: "st12",
    d: "M312,159.7c-1.5-0.6-3-1-4.6-1.2c-1.3-0.2-1.3,1.9,0,2.1c1.4,0.2,2.8,0.5,4.1,1.1 C312.7,162.2,313.2,160.2,312,159.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282_1_",
    className: "st12",
    d: "M324.9,156.7l-3.3,1c-1.3,0.4-0.7,2.4,0.5,2l3.3-1C326.7,158.3,326.1,156.3,324.9,156.7 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142_1_",
    transform: "translate(160.04 93.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_130_1_",
    className: "st1",
    d: "M105.2-10.2h224.6c32.5,0,58.9,26.4,58.9,58.9c0,0,0,0,0,0v88.5l0,0H105.2 c-32.5,0-58.9-26.4-58.9-58.9c0,0,0,0,0,0V48.8C46.2,16.2,72.6-10.2,105.2-10.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141_1_",
    transform: "translate(41.494 20.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283_1_",
    className: "st18",
    d: "M129.5,56.5h-6.3v11.1h-15.3V56.5H85V45.1l23.8-34.9h14.3v34.7h6.3L129.5,56.5z  M107.9,44.9v-6.7c0-1.3,0-2.9,0.1-5.1c0-1.1,0.1-2.2,0.2-3.4h-0.4c-0.9,2-1.9,3.8-3,5.6l-6.4,9.4H107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284_1_",
    className: "st18",
    d: "M191,39c0,10.1-1.7,17.6-5.1,22.3s-8.6,7.1-15.6,7.1c-6.8,0-12-2.5-15.5-7.4 c-3.5-4.9-5.2-12.3-5.2-22c0-10.2,1.7-17.7,5.1-22.4c3.4-4.8,8.6-7.1,15.6-7.1c6.1-0.4,11.9,2.5,15.5,7.4 C189.3,21.8,191,29.2,191,39z M165,39c-0.2,4.5,0.2,9,1.2,13.4c0.8,2.4,2.2,3.6,4.1,3.6c1.9,0,3.3-1.3,4.1-3.8 c1-4.3,1.4-8.8,1.2-13.3c0.2-4.5-0.2-9-1.2-13.4c-0.8-2.5-2.2-3.8-4.1-3.8s-3.3,1.2-4.1,3.7C165.2,29.9,164.8,34.5,165,39L165,39 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285_1_",
    className: "st18",
    d: "M255.7,56.5h-6.3v11.1h-15.3V56.5h-22.9V45.1l23.8-34.9h14.3v34.7h6.3V56.5z  M234.1,44.9v-6.7c0-1.3,0-2.9,0.1-5.1c0-1.1,0.1-2.2,0.2-3.4h-0.4c-0.9,2-1.9,3.8-3,5.6l-6.4,9.4H234.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144_1_",
    transform: "translate(125.453 188.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_131_1_",
    className: "st1",
    d: "M58.4,78.1h161.3c24.6,0,44.6,19.9,44.6,44.6v66.9l0,0H58.4 c-24.6,0-44.6-19.9-44.6-44.6v-22.3C13.9,98,33.8,78.1,58.4,78.1C58.4,78.1,58.4,78.1,58.4,78.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143_1_",
    transform: "translate(35.072 23.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286_1_",
    className: "st18",
    d: "M57.6,122.3c-3,0.2-5.9-0.9-8.1-2.8c-2-2.2-3.1-5.1-2.9-8.1c-0.2-3,0.8-6,2.7-8.3 c1.9-2,4.6-3.1,7.4-2.9c2.6-0.2,5.2,0.8,7,2.6c1.8,1.9,2.7,4.5,2.5,7.1v2.8H52.6c0,1.4,0.5,2.8,1.5,3.9c1,1,2.4,1.5,3.9,1.4 c1.2,0,2.5-0.1,3.6-0.4c1.2-0.3,2.4-0.7,3.6-1.3v4.5c-1,0.5-2.1,0.9-3.3,1.1C60.5,122.2,59.1,122.3,57.6,122.3z M56.8,104.3 c-1.1-0.1-2.2,0.4-2.9,1.2c-0.8,0.9-1.2,2.1-1.2,3.3h8.2c0.1-1.2-0.3-2.4-1.1-3.3C59,104.7,57.9,104.3,56.8,104.3L56.8,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287_1_",
    className: "st18",
    d: "M86.9,100.2c0.7,0,1.3,0,2,0.2l-0.4,5.5c-0.6-0.1-1.1-0.2-1.7-0.2 c-1.6-0.1-3.1,0.4-4.3,1.4c-1.1,1-1.6,2.5-1.5,4v10.9H75v-21.3h4.4l0.9,3.6h0.3c0.6-1.2,1.6-2.2,2.7-2.9 C84.3,100.6,85.6,100.2,86.9,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288_1_",
    className: "st18",
    d: "M108.6,100.2c0.7,0,1.3,0,2,0.2l-0.4,5.5c-0.6-0.1-1.1-0.2-1.7-0.2 c-1.6-0.1-3.1,0.4-4.3,1.4c-1.1,1-1.6,2.5-1.5,4v10.9h-5.8v-21.3h4.4l0.9,3.6h0.3c0.6-1.2,1.6-2.2,2.7-2.9 C106,100.6,107.3,100.2,108.6,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289_1_",
    className: "st18",
    d: "M137.7,111.2c0.2,3-0.8,5.9-2.7,8.1c-2,2-4.8,3.1-7.7,2.9c-1.9,0-3.8-0.4-5.4-1.4 c-1.6-0.9-2.8-2.2-3.6-3.9c-0.9-1.8-1.3-3.8-1.3-5.9c-0.2-3,0.8-5.9,2.7-8.1c2-2,4.8-3.1,7.7-2.9c1.9,0,3.8,0.4,5.4,1.3 c1.6,0.9,2.8,2.2,3.6,3.8C137.3,107.2,137.8,109.2,137.7,111.2z M123,111.2c-0.1,1.7,0.3,3.3,1,4.8c0.8,1.1,2,1.7,3.4,1.6 c1.3,0.1,2.6-0.5,3.4-1.6c0.8-1.5,1.1-3.1,1-4.8c0.1-1.7-0.2-3.3-1-4.8c-1.5-1.9-4.3-2.1-6.2-0.6c-0.2,0.2-0.4,0.4-0.6,0.6 C123.2,107.9,122.9,109.6,123,111.2L123,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290_1_",
    className: "st18",
    d: "M158.4,100.2c0.7,0,1.3,0,2,0.2l-0.4,5.5c-0.6-0.1-1.1-0.2-1.7-0.2 c-1.6-0.1-3.1,0.4-4.3,1.4c-1.1,1-1.6,2.5-1.5,4v10.9h-5.8v-21.3h4.4l0.9,3.6h0.3c0.6-1.2,1.6-2.2,2.7-2.9 C155.8,100.6,157,100.2,158.4,100.2z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Caminho_291_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9135,
    y1: 784.9037,
    x2: 2.2762,
    y2: 786.1636,
    gradientTransform: "matrix(94.2368 0 0 -133.0687 245.5494 104969.4609)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.302
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291_1_",
    className: "st19",
    d: "M648.9,605.3l-53.6-199.9c-7.5-28.1-32.7-47.9-61.8-48.5l0,0 c-55.2-1.2-87,62.3-52.9,105.8c56,71.4,117.9,151.7,117.9,151.7L648.9,605.3z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147_1_",
    transform: "translate(338.698 177.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_132_1_",
    className: "st1",
    d: "M249.9,67.6h113.4c20.2,0,36.5,16.4,36.5,36.5c0,0,0,0,0,0v18.3 c0,20.2-16.4,36.5-36.5,36.5c0,0,0,0,0,0h-150l0,0v-54.9C213.3,84,229.7,67.6,249.9,67.6C249.9,67.6,249.9,67.6,249.9,67.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146_1_",
    transform: "translate(31.426 21.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_28_1_",
    className: "st18",
    cx: 247.5,
    cy: 92.2,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292_1_",
    className: "st18",
    d: "M280,92.2c0,2.7-2.2,4.8-4.8,4.8s-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8l0,0 C277.8,87.4,280,89.5,280,92.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_29_1_",
    className: "st18",
    cx: 302.8,
    cy: 92.2,
    r: 4.8
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149_1_",
    transform: "translate(150.194 353.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148_1_",
    transform: "translate(40.747 5.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293_1_",
    className: "st3",
    d: "M83.1,270.2c-2.7,0-5.3-0.2-7.9-0.8l0.9-4.3c9,1.9,23.8-0.1,28-8.7 c1.3-2.7,1.3-5.9-0.1-8.5c-1.3-2.6-3.6-4.6-6.5-5.4c-5.6-1.7-12.9,0.2-17.6,2.9l-2.2-3.9c5.2-2.9,13.8-5.5,21.1-3.3 c4,1.2,7.3,3.9,9.1,7.6c1.9,3.9,2,8.5,0.1,12.5C103.8,267,92.7,270.2,83.1,270.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_133_1_",
    className: "st3",
    d: "M59.2,232.6h72l0,0v31.1c0,14.6-11.9,26.5-26.5,26.5c0,0,0,0,0,0h-19 c-14.6,0-26.5-11.9-26.5-26.5V232.6L59.2,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294_1_",
    className: "st3",
    d: "M151.1,294.6H40.3c-1.8,0-3.3-1.5-3.3-3.3l0,0l0,0c0-1.8,1.5-3.3,3.3-3.3h110.7 c1.8,0,3.3,1.5,3.3,3.3l0,0C154.4,293.1,152.9,294.6,151.1,294.6L151.1,294.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156_1_",
    transform: "translate(256.944 252.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_134_1_",
    className: "st18",
    d: "M141.7,386.1h256.6c2.7,0,4.8,2.2,4.8,4.8v2.4c0,2.7-2.2,4.8-4.8,4.8H141.7 c-2.7,0-4.8-2.2-4.8-4.8v-2.4C136.9,388.2,139,386.1,141.7,386.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_303_1_",
    className: "st18",
    d: "M404,398.2H176.4l19.8-130.7c0.6-4.5,4.5-7.9,9-7.9h209.5c4.9,0.1,8.8,4.1,8.8,9 c0,0.5,0,0.9-0.1,1.4L404,398.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_30_1_",
    className: "st20",
    cx: 311,
    cy: 319.5,
    r: 10.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155_1_",
    transform: "translate(94.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_304_1_",
    className: "st4",
    d: "M227.5,249.4c-1.4-6-2-12.1-2-18.2c0-6,0.9-10.3,4.9-14.9c3-3.4,6.2-6.6,9.7-9.6 c9.1-7.6,12.4-20.2,8.2-31.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_305_1_",
    className: "st4",
    d: "M246.6,231.8c-1.2-5.1,1.6-10.4,5.2-14.3c3.6-3.9,8-7,11.1-11.2 c6.7-9.1,6.4-17.7,5.2-34.6c-0.9-11.9-0.6-25.4,7.9-33.7"
  })))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_135_1_",
    className: "st21",
    d: "M75.3,646h661.3c3.2,0,5.8,2.6,5.8,5.8v2.9c0,3.2-2.6,5.8-5.8,5.8H75.3 c-3.2,0-5.8-2.6-5.8-5.8v-2.9C69.5,648.6,72.1,646,75.3,646z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M719.3,573.7c0.6-4,1.9-7.6,5.1-9.4c4.5-2.6,10.5-0.4,15.7-1.4c14.6-2.7,14.5-23.2,14.2-34.4 c-0.2-7.2-0.5-14.3-1-21.5c0-1.9-0.4-3.8-1.3-5.5c-2.1-2.8-5.8-4-9.1-2.8c-6.4,1.8-10,8.7-11.1,15.3c-1.1,6.6-0.6,13.4-2.3,19.8 c-0.3,1.2-0.8,2.4-1.4,3.4c-0.8,1.2-1.9,2.1-3.2,2.7c-1.9,1-4.1,0.9-5.9-0.1c-2-1.3-1.7-2.9-1.7-4.9c-0.1-2.4-0.3-4.8-0.6-7.2 c-0.6-5.4-1.2-10.8-1.7-16.2c-1-10.6-1.9-21.2-3-31.8c-0.2-4.9-1.4-9.7-3.5-14.2c-10.5-18.8-26.4-2.3-27.9,11.4 c-3.3,31.2,12.9,60.6,11.6,91.6c0,1.3-0.2,2.6-0.7,3.8c-2.4,4.9-10.3,4-13.9,1.2c-5.7-4.4-3.6-14-3.6-19.7c0-4.7-1.5-10-6-12.2 c-5.1-2.5-11.9,0.5-14.8,5.1c-3.8,5.9-3.4,16.1-2.8,22.7c0.2,4.9,1.7,9.6,4.4,13.7c2.9,4.3,7.6,7.1,12.7,7.5 c3,0.2,6.5-0.5,8.8,1.4c2.8,2.2,1.8,6.2,1.9,9.6c0.2,6.7,5.9,12.4,12.6,15.2s14.2,3.3,21.5,3.7c6.2-10,6.6-21.5,6.9-32.6 C718.8,583.4,718.9,578.5,719.3,573.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152_1_",
    transform: "translate(331.173 330.179)",
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295_1_",
    className: "st1",
    d: "M388.1,243.5c0.6-4,1.9-7.6,5.1-9.4c4.5-2.6,10.5-0.4,15.7-1.4 c14.6-2.7,14.5-23.2,14.2-34.4c-0.2-7.2-0.5-14.3-1-21.5c0-1.9-0.4-3.8-1.3-5.5c-2.1-2.8-5.8-4-9.1-2.8 c-6.4,1.8-10,8.7-11.1,15.3c-1.1,6.6-0.6,13.4-2.3,19.8c-0.3,1.2-0.8,2.4-1.4,3.4c-0.8,1.2-1.9,2.1-3.2,2.7 c-1.9,1-4.1,0.9-5.9-0.1c-2-1.3-1.7-2.9-1.7-4.9c-0.1-2.4-0.3-4.8-0.6-7.2c-0.6-5.4-1.2-10.8-1.7-16.2c-1-10.6-1.9-21.2-3-31.8 c-0.2-4.9-1.4-9.7-3.5-14.2c-10.5-18.8-26.4-2.3-27.9,11.4c-3.3,31.2,12.9,60.6,11.6,91.6c0,1.3-0.2,2.6-0.7,3.8 c-2.4,4.9-10.3,4-13.9,1.2c-5.7-4.4-3.6-14-3.6-19.7c0-4.7-1.5-10-6-12.2c-5.1-2.5-11.9,0.5-14.8,5.1 c-3.8,5.9-3.4,16.1-2.8,22.7c0.2,4.9,1.7,9.6,4.4,13.7c2.9,4.3,7.6,7.1,12.7,7.5c3,0.2,6.5-0.5,8.8,1.4 c2.8,2.2,1.8,6.2,1.9,9.6c0.2,6.7,5.9,12.4,12.6,15.2s14.2,3.3,21.5,3.7c6.2-10,6.6-21.5,6.9-32.6 C387.7,253.2,387.8,248.3,388.1,243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296_1_",
    className: "st2",
    d: "M368.4,128.2c7.5,51.8,13.9,104.5,4.7,156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297_1_",
    className: "st2",
    d: "M361.3,127.9c-2.1,9.6-4.2,19.4-4.2,29.2c0.1,18.7,8,36.7,11.1,55.2 c3.5,20.7,0.9,41.8-1.7,62.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298_1_",
    className: "st2",
    d: "M377.4,219.2c9-1.3,19.8-2.6,25.5-9.8c0.8-1,1.5-2.1,1.9-3.4 c1.5-4.9,0.8-10.5,0.7-15.5c0-4.8,0.1-13.3,0.1-19.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299_1_",
    className: "st2",
    d: "M369.3,253.6c-8.1,1.3-17.1,2.5-24-1.5c-4.1-2.5-7.2-6.4-8.7-10.9 c-1.4-4.4-2-9-1.8-13.6c0-5,0.4-10,1.3-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300_1_",
    className: "st2",
    d: "M377.5,227.5c10.3-1.5,20.3-4.1,30-7.8c2.1-0.6,4-1.7,5.6-3.1c1.5-1.7,2.5-3.6,3-5.8 c1.4-4.7,2-36.7,0.5-44.5"
  })))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_302_1_",
    className: "st3",
    d: "M670.3,603.7l60.6-1.3l-6.2,45.2l-46.3,0L670.3,603.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotfound);
export default __webpack_public_path__ + "static/media/pageNotfound.98c50e0f1b50940c119131f60b626523.svg";
export { ForwardRef as ReactComponent };